const h1Regular = {
  fontWeight: 600,
  fontSize: '8rem',
  lineHeight: '8.8rem',
  letterSpacing: '-0.2px'
}

const h1Medium = {
  fontWeight: 600,
  fontSize: '4.8rem',
  lineHeight: '5.6rem',
  letterSpacing: '-.1rem'
}

const h2Regular = {
  fontWeight: 600,
  fontSize: '3.6rem',
  lineHeight: '115%'
}

const h2Bold = {
  fontFamily: 'Roboto',
  fontWeight: 700,
  fontSize: '6rem',
  lineHeight: '120%',
  letterSpacing: '-.05rem',
  mobileSize: '3.9rem',
  mobilelineHeight: '4.7rem'
}

const h3Bold = {
  ...h2Bold,
  lineHeight: '116.7%',
  fontSize: '4.8rem',
  fontFamily: 'Roboto',
  mobileSize: '3rem',
  mobilelineHeight: '4.8rem'
}

const h3Regular = {
  fontWeight: 700,
  fontSize: '2.4rem',
  lineHeight: '115%',
  letterSpacing: '-0.25px'
}

const h4Regular = {
  fontWeight: 700,
  fontSize: '2.4rem',
  lineHeight: '115%',
  letterSpacing: '-0.25px'
}

const h4Bold = {
  fontFamily: 'Roboto',
  fontWeight: 700,
  fontSize: '3.4rem',
  lineHeight: '123.5%',
  letterSpacing: '.025rem',
  mobileSize: '3rem',
  mobilelineHeight: '3.6rem'
}

const h5Regular = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '2.4rem',
  lineHeight: '133.4%',
  letterSpacing: '-.025rem'
}

const h5Bold = {
  fontWeight: 700,
  fontSize: '2.4rem',
  lineHeight: '133.4%',
  mobileSize: '2.1rem',
  mobilelineHeight: '2.8rem'
}

const h6Bold = {
  fontWeight: 700,
  fontSize: '2rem',
  lineHeight: '160%',
  letterSpacing: '-0.015rem',
  mobileSize: '1.5rem'
}

const body1Regular = {
  fontWeight: 600,
  fontSize: '4.8rem',
  lineHeight: '5.6rem',
  letterSpacing: '-.1rem',
  mobileSize: '4rem',
  mobilelineHeight: '7rem'
}

const body1Small = {
  fontWeight: 500,
  fontSize: '1.4rem',
  lineHeight: '2rem'
}

const body2Regular = {
  fontWeight: 500,
  fontSize: '1.4rem',
  lineHeight: '2rem',
  letterSpacing: '-0.25px'
}

const body2Medium = {
  ...body2Regular,
  lineHeight: '2rem'
}
const body2Light = {
  ...body2Regular,
  fontSize: '1.6rem',
  lineHeight: '150%',
  letterSpacing: '0.15px',
  fontWeight: 400
}

const caption = {
  fontWeight: 500,
  fontSize: '1.6rem',
  lineHeight: '2.4rem',
  letterSpacing: '-0.25px',
  mobileSize: '1.3rem',
  mobilelineHeight: '2.1rem'
}

const smallText = {
  fontWeight: 700,
  fontSize: '1.6rem',
  lineHeight: '1.9rem',
  letterSpacing: '0.15px'
}

const popupText = {
  fontWeight: 500,
  fontSize: '1.8rem',
  lineHeight: '2.7rem'
}

const cardTitle = {
  ...h3Bold,
  mobileSize: '1.4rem',
  lineHeight: '3.5rem'
}

const cardContent = {
  ...body2Medium,
  mobileSize: '1.1rem',
  lineHeight: '1.7rem'
}
let typography = {
  h1Regular,
  h2Regular,
  h2Bold,
  h1Medium,
  h3Regular,
  smallText,
  h5Bold,
  caption,
  h3Bold,
  h4Regular,
  h4Bold,
  h5Regular,
  h6Bold,
  body1Regular,
  body2Medium,
  body1Small,
  body2Regular,
  body2Light,
  popupText,
  cardTitle,
  cardContent
}

export default typography
